export default function translateOfferStatus(status) {
    if (status === "open") return "Offen";
    else if (status === "concluded") return "Abgeschlossen";
    else if (status === "expired") return "Abgelaufen";
    else return "-/-";
}
